$(document).ready(function () {
  // Add custom code below this line
  setInterval(function time() {
    var d = new Date();
    var d1 = new Date();
    d.setHours(d1.getHours() + 12);
    var hours = 23 - d.getHours();
    var min = 60 - d.getMinutes();
    if ((min + "").length == 1) {
      min = "0" + min;
    }
    var sec = 60 - d.getSeconds();
    if ((sec + "").length == 1) {
      sec = "0" + sec;
    }
    $(".timer").html(hours + " timer " + min + " min " + sec + " sek");

    var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    var currentDateNew = new Date(new Date().getTime() + 0 * 60 * 60 * 1000);
    var day = currentDateNew.getDate();
    let dayN = "th";
    switch (day) {
      case 1:
        dayN = "st";
        break;
      case 2:
        dayN = "nd";
        break;
      case 3:
        dayN = "rd";
        break;
      default:
        dayN = "th";
    }
    var month = currentDate.getMonth() + 1;
    var year = currentDate.getFullYear();
    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    $(".date-product").html(
      days[currentDateNew.getDay()] +
        ", " +
        day +
        " " +
        monthNames[currentDateNew.getMonth()]
    );

    var currentDay = days[currentDateNew.getDay()];
    var currentHour = currentDateNew.getHours();

    if (
      currentDay === "Saturday" ||
      currentDay === "Sunday" ||
      (currentDay === "Friday" && currentHour >= 12)
    ) {
      $(".timer--outer").html("Bestil nu og vi sender din pakke på mandag");
    } else if (hours >= 12) {
      $(".today-tomorrow-i").html("imorgen.");
    } else {
      $(".today-tomorrow-i").html("idag.");
    }
  }, 1000);
});


function cartClickAgree() {
  $(".Cart__Agree").click(function () {
    if ($(this).is(":checked")) {
      $(".mini-cart .button-container button").removeAttr("disabled"); //enable input
    } else {
      $(".mini-cart .button-container button").attr("disabled", true); //disable input
    }
  });
}
cartClickAgree();

$(".read-more--collection").click(function () {
  $(this).parent().slideUp().next().slideDown();
});



$(document).ready(function () {
  $(".featured-product-grid").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // for tablets and small laptops
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // for tablets and large phones
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // for mobile
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2500,
        },
      },
    ],
  });

  // Custom next/prev buttons
  $(".prev-btn").click(function () {
    $(".featured-product-grid").slick("slickPrev");
  });

  $(".next-btn").click(function () {
    $(".featured-product-grid").slick("slickNext");
  });

  // Disable/enable button states
  $(".prev-btn").addClass("slick-disabled");
  $(".featured-product-grid").on("afterChange", function () {
    if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prev-btn").addClass("slick-disabled");
    } else {
      $(".prev-btn").removeClass("slick-disabled");
    }
    if ($(".slick-next").hasClass("slick-disabled")) {
      $(".next-btn").addClass("slick-disabled");
    } else {
      $(".next-btn").removeClass("slick-disabled");
    }
  });
});

$(document).ready(function () {
  $(".gallery-grid-slider").slick({
    slidesToShow: 4.3,
    slidesToScroll: 1,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // for tablets and small laptops
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // for mobile
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2500,
        },
      },
    ],
  });

  // Custom next/prev buttons
  $(".prev-btnn").click(function () {
    $(".gallery-grid-slider").slick("slickPrev");
  });

  $(".next-btnn").click(function () {
    $(".gallery-grid-slider").slick("slickNext");
  });

  // Disable/enable button states
  $(".prev-btnn").addClass("slick-disabled");
  $(".gallery-grid-slider").on("afterChange", function () {
    if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prev-btnn").addClass("slick-disabled");
    } else {
      $(".prev-btnn").removeClass("slick-disabled");
    }
    if ($(".slick-next").hasClass("slick-disabled")) {
      $(".next-btnn").addClass("slick-disabled");
    } else {
      $(".next-btnn").removeClass("slick-disabled");
    }
  });
});

// Inject image into QBK offer if missing
$(document).ready(function() {
  setInterval(function() {
    // Target the QBK offer image container
    var imgContainer = $('.qbk-offer__image');
    
    // If the container exists, is empty (no img child), and we have the image URL
    if (imgContainer.length > 0 && imgContainer.find('img').length === 0 && window.giftWrappingImageUrl) {
        // Check if it already has background image
        if (imgContainer.css('background-image') === 'none' || imgContainer.css('background-image') === '') {
             // Inject the image
             imgContainer.html('<img src="' + window.giftWrappingImageUrl + '" style="width:100%;height:100%;object-fit:cover;">');
             // Alternatively, set background image
             // imgContainer.css('background-image', 'url(' + window.giftWrappingImageUrl + ')');
             // imgContainer.css('background-size', 'cover');
        }
    }
  }, 1000); // Check every second
});
